import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:id/edit',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TeamUpdateContainer',
      './modules/teamUpdate'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const TeamUpdate = require('./containers/TeamUpdateContainer').default
      const actions = require('./modules/teamUpdate')
      const actionsScreeningConfig = require('../ScreeningConfig/modules/screeningConfig')
      const reducer = require('./modules/teamUpdate').default
      const reducerScreeningConfig = require('../ScreeningConfig/modules/screeningConfig').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'teamUpdate', reducer: reducer })
      injectReducer(store, { key: 'screeningConfig', reducer: reducerScreeningConfig })

      store.dispatch(actions.fetchTeam(nextState.params.id))
      store.dispatch(actionsScreeningConfig.fetchConfig(nextState.params.id))

      /*  Return getComponent   */
      cb(null, TeamUpdate)

    /* Webpack named bundle   */
    }, 'teamUpdate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/TeamUpdate/index.js